export enum ClaimClass {
  TEXT = 'TEXT',
  LOGO = 'LOGO',
  PRODUCT = 'PRODUCT',
  PERSON = 'PERSON',
  DISCLAIMER = 'QUALIFIER',
  OTHER = 'OTHER',
}
